export default "__VITE_ASSET__Bnq_slMe__"